import styled from "@emotion/styled";
import { keyframes, css } from '@emotion/react';
import { tablet } from "../../../media";

const slideDown = keyframes`
  from { transform: translateY(0); opacity: 1; }
  to { transform: translateY(100%); opacity: 0; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const DockWrapper = styled.div<{ isAnimatingOut?: boolean; isAnimatingIn?: boolean; isKeyboardOpen?: boolean }>`
    position: relative;
    border-radius: 12px;

    margin: 0 16px 0;
    width: auto;

    ${tablet`
        max-width: 720px;
        margin-left: auto;
        margin-right: auto;
    `}

    background: #23252a;
    border-top: 1px solid #2b2d33;
    box-shadow: 0px -2px 12px rgba(94, 132, 237, 0.45);

    display: flex;
    z-index: 10;

    flex-direction: column;
    min-height: 160px;
    max-height: calc(100dvh - 140px);
    padding: 16px;
    gap: 12px;
    box-sizing: border-box;

    ${props => props.isAnimatingOut && css`
      animation: ${slideDown} 0.3s forwards;
    `}

    ${props => props.isAnimatingIn && css`
      animation: ${slideUp} 0.3s forwards;
    `}
`;

export const DockHandleWrapper = styled.div`
    height: 12px;
    justify-content: center;
    align-items: center;
    display: inline-flex;
`;

export const DockHandle = styled.div`
  width: 36px;
  height: 4px;
  background: #2B2D33;
  border-radius: 999px;
`;

export const AttachedFiles = styled.div`
  gap: 6px;
  display: flex;
  flex-direction: column;
  max-height: 108px;
  overflow-y: auto;
`;

export const AttachedFileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`;

export const AttachedFile = styled.div`
// height: 32px;
  min-width: 100%;
  width: fit-content;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  outline: 1px #2B2D33 solid;
  outline-offset: -1px;
  align-items: center;
  gap: 10px;
  display: inline-flex;
`;

export const AttachIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const AttachedFileName = styled.span`
  color: #E9ECF5;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 21px;
  word-wrap: break-word;
  flex: 1;
`;

export const AttachedCancelIcon = styled.img`
width: 21px;
height: 21px;
cursor: pointer;
margin-left: 18px;
`;

export const AttachFileUploadingProgress = styled.div`
  width: 185.96px;
  height: 3px;
  background: #5E84ED;
  border-radius: 9999px;
`;

export const DockTextArea = styled.textarea`
  max-height: 120px;
  min-height: 56px;
  padding: 12px;
  border-radius: 12px;
  border: none;
  background: transparent;
  resize: none;
  outline: none;

  color: #B7BDCB;
  font-size: 16px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;

export const DockActions = styled.div`
  display: inline-flex;
  align-self: stretch;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
`;

export const DockActionButtonContainer = styled.div`
  width: 60px;
  height: 60px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const DockActionButton = styled.button`

`;

export const DockItem = styled.button`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    height: 60px;
    width: 60px;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid #b7bdcb;
        outline-offset: 2px;
    }
`;

export const DockIcon = styled.img`
    display: block;
`;

export const CharacterCount = styled.div<{ isNearLimit?: boolean }>`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  color: ${(props) => (props.isNearLimit ? '#ff8800' : '#6e7481')};
  text-align: right;
  padding: 0 12px;
  margin-top: -8px;
`;

export const UploadHint = styled.div<{ isNearLimit?: boolean }>`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  color: ${(props) => (props.isNearLimit ? '#ff8800' : '#6e7481')};
  padding: 0 4px;
`;

export const FileError = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #b94c37;
  padding: 0 4px;
`;

export const DockLabel = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 11px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;
